"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relativeDateFromString = void 0;
const date_1 = require("./date");
const parseDate = (name) => {
    const periods = ['days', 'weeks', 'months', 'years'];
    let num = 0;
    let period = '';
    period = periods.find((p) => name.endsWith(p)) || 'date';
    num = parseInt(name) || 0;
    return {
        num: num,
        period: period,
    };
};
const relativeDateFromString = (name) => {
    if (!name) {
        return '';
    }
    const { num, period } = parseDate(name);
    let date = new date_1.DateValue();
    switch (period) {
        case 'date':
            date = new date_1.DateValue(name);
            break;
        case 'days':
            date.addDays(num);
            break;
        case 'weeks':
            date.addDays(num * 7);
            break;
        case 'months':
            date.addMonths(num);
            break;
        case 'years':
            date.addYears(num);
            break;
    }
    return date.toString();
};
exports.relativeDateFromString = relativeDateFromString;
